export const getFullYear = () => {
    let date = new Date();

    return date.getFullYear();
};
